import { render, staticRenderFns } from "./ClientPanel.vue?vue&type=template&id=dc95eba4&scoped=true"
import script from "./ClientPanel.vue?vue&type=script&lang=js"
export * from "./ClientPanel.vue?vue&type=script&lang=js"
import style0 from "./ClientPanel.vue?vue&type=style&index=0&id=dc95eba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc95eba4",
  null
  
)

export default component.exports